<div class="customer-details-partial">
  <div class="fw-bold mb-2 d-none d-sm-block"
       [translate]="'receipt.yourDetails'">
  </div>

  <div class="mt-1 font-md" *ngIf="multiOrder.userCompanyName">
    <span [translate]="'receipt.userDetails.company'"></span>:&nbsp;
    <strong>{{ multiOrder.userCompanyName }}</strong>
  </div>

  <div class="mt-1 font-md">
    <span [translate]="'receipt.userDetails.yourName'"></span>:&nbsp;
    <strong>{{ multiOrder.userName }}</strong>
  </div>

  <div class="mt-1 font-md"
       *ngIf="multiOrder.customer?.contactEmail">
    <span [translate]="'receipt.userDetails.email'"></span>:&nbsp;
    <strong>{{ multiOrder.customer.contactEmail }}</strong>
  </div>

  <div class="mt-1 font-md"
       *ngIf="multiOrder.userPhone">
    <span [translate]="'receipt.userDetails.phone'"></span>:&nbsp;
    <strong>{{ multiOrder.userPhone }}</strong>
  </div>
</div>

<ng-content></ng-content>

<div class="mt-3 d-none d-sm-block" *ngIf="showStartNewOrder">
  <button class="btn font-lg btn-outline-pink new-order-btn"
          (click)="onStartNewOrderClick.emit()"
          [translate]="'receipt.startNewOrder'">
  </button>
</div>
